function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "bg-white-kinedu-educators-es_svg__a",
  d: "M.082 35.59h327.836V.328H.082z"
}), /*#__PURE__*/React.createElement("path", {
  id: "bg-white-kinedu-educators-es_svg__c",
  d: "M.082 35.59h327.836V.328H.082z"
}), /*#__PURE__*/React.createElement("path", {
  id: "bg-white-kinedu-educators-es_svg__e",
  d: "M.082 35.59h327.836V.328H.082z"
}), /*#__PURE__*/React.createElement("path", {
  id: "bg-white-kinedu-educators-es_svg__g",
  d: "M.082 35.59h327.836V.328H.082z"
}), /*#__PURE__*/React.createElement("path", {
  id: "bg-white-kinedu-educators-es_svg__i",
  d: "M.082 35.59h327.836V.328H.082z"
}), /*#__PURE__*/React.createElement("path", {
  id: "bg-white-kinedu-educators-es_svg__k",
  d: "M.082 35.59h327.836V.328H.082z"
}), /*#__PURE__*/React.createElement("path", {
  id: "bg-white-kinedu-educators-es_svg__m",
  d: "M.082 35.59h327.836V.328H.082z"
}), /*#__PURE__*/React.createElement("path", {
  id: "bg-white-kinedu-educators-es_svg__o",
  d: "M.082 35.59h327.836V.328H.082z"
}), /*#__PURE__*/React.createElement("path", {
  id: "bg-white-kinedu-educators-es_svg__q",
  d: "M.082 35.59h327.836V.328H.082z"
}), /*#__PURE__*/React.createElement("path", {
  id: "bg-white-kinedu-educators-es_svg__s",
  d: "M.082 35.59h327.836V.328H.082z"
}), /*#__PURE__*/React.createElement("path", {
  id: "bg-white-kinedu-educators-es_svg__u",
  d: "M.082 35.59h327.836V.328H.082z"
}), /*#__PURE__*/React.createElement("path", {
  id: "bg-white-kinedu-educators-es_svg__w",
  d: "M.082 35.59h327.836V.328H.082z"
}), /*#__PURE__*/React.createElement("path", {
  id: "bg-white-kinedu-educators-es_svg__y",
  d: "M.082 35.59h327.836V.328H.082z"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M48.28 30.833L49 32h-6.32l-4.88-8-1.52 1.667V32H31l.08-27h5.2v13.25l5.84-6.583H49l-7.52 8.416zM57.482 12.11V32.072h-5.33V12.109h5.33zm.328-5.237a2.936 2.936 0 01-2.952 2.945c-1.64 0-3.034-1.309-3.034-2.945 0-1.637 1.394-3.028 3.034-3.028 1.64.082 2.952 1.391 2.952 3.028zM80.032 22.336v9.655h-5.248v-9.655c0-2.372-1.23-4.745-4.018-4.745a4.754 4.754 0 00-4.756 4.745v9.655h-5.248V12.027h5.248v1.555c1.394-.737 3.034-1.227 4.756-1.227 5.33 0 9.266 4.254 9.266 9.981M87.084 21.682l8.61-2.537c-1.558-4.09-9.43-1.718-8.61 2.537zm14.842 3.6c-2.132 4.909-6.724 8.182-12.136 6.954-4.838-1.063-8.446-5.727-7.954-10.963 1.148-12.437 18.532-11.946 19.762.327-4.428 1.39-8.938 2.618-13.366 3.927 2.542 3.028 7.134 1.8 8.692-1.636l5.002 1.39zM118.572 22.5a4.754 4.754 0 00-4.756-4.745 4.754 4.754 0 00-4.756 4.745 4.754 4.754 0 004.756 4.745 4.754 4.754 0 004.756-4.745m0-8.836l.082-8.182h5.248v26.673h-5.248v-.9c-1.394.818-3.034 1.227-4.756 1.227-5.494 0-10.004-4.5-10.004-9.982 0-5.482 4.51-9.982 10.004-9.982 1.64 0 3.28.41 4.674 1.146M126.608 22.5V12.436h5.248V22.5c0 2.373 1.23 4.745 4.018 4.745a4.754 4.754 0 004.756-4.745V12.436h5.248v20.046h-5.248v-1.146c-1.394.737-3.034 1.228-4.756 1.228-5.33-.082-9.266-4.255-9.266-10.064M23.534 32.073c0-6.791-5.74-12.273-12.3-12.273v12.273h12.3z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
  id: "bg-white-kinedu-educators-es_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#bg-white-kinedu-educators-es_svg__a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  mask: "url(#bg-white-kinedu-educators-es_svg__b)",
  d: "M.082 31.99h9.184V19.8H.082z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
  id: "bg-white-kinedu-educators-es_svg__d",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#bg-white-kinedu-educators-es_svg__c"
})), /*#__PURE__*/React.createElement("path", {
  d: "M16.4 7.69c2.87 0 5.166 2.292 5.166 5.155A5.139 5.139 0 0116.4 18a5.139 5.139 0 01-5.166-5.155A5.139 5.139 0 0116.4 7.691",
  fill: "#FFF",
  mask: "url(#bg-white-kinedu-educators-es_svg__d)"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
  id: "bg-white-kinedu-educators-es_svg__f",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#bg-white-kinedu-educators-es_svg__e"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  mask: "url(#bg-white-kinedu-educators-es_svg__f)",
  d: "M.082 17.836h9.184V5.564H.082z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
  id: "bg-white-kinedu-educators-es_svg__h",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#bg-white-kinedu-educators-es_svg__g"
})), /*#__PURE__*/React.createElement("path", {
  d: "M171.298 17.345c-3.444 0-5.166 2.864-5.248 5.319h10.578c-.082-2.373-1.722-5.319-5.33-5.319m-7.954 6.3c0-4.663 3.362-8.427 7.954-8.427 4.838 0 7.708 3.764 7.708 8.591v.655H166.05c.164 3.027 2.296 5.563 5.74 5.563a7.08 7.08 0 005.002-2.045l1.23 1.636c-1.64 1.555-3.772 2.455-6.396 2.455-4.838 0-8.282-3.437-8.282-8.428",
  fill: "#FFF",
  mask: "url(#bg-white-kinedu-educators-es_svg__h)"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
  id: "bg-white-kinedu-educators-es_svg__j",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#bg-white-kinedu-educators-es_svg__i"
})), /*#__PURE__*/React.createElement("path", {
  d: "M194.012 27.327v-7.2c-.902-1.39-2.788-2.618-4.756-2.618-3.28 0-5.166 2.618-5.166 6.218 0 3.518 1.968 6.137 5.166 6.137 1.968 0 3.936-1.146 4.756-2.537zm0 4.337V29.29c-1.23 1.636-3.198 2.782-5.412 2.782-4.182 0-7.134-3.191-7.134-8.428 0-5.154 2.952-8.427 7.134-8.427 2.132 0 4.1 1.064 5.412 2.864v-8.51h2.46v22.173h-2.46v-.081z",
  fill: "#FFF",
  mask: "url(#bg-white-kinedu-educators-es_svg__j)"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
  id: "bg-white-kinedu-educators-es_svg__l",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#bg-white-kinedu-educators-es_svg__k"
})), /*#__PURE__*/React.createElement("path", {
  d: "M211.724 31.664v-2.21c-1.23 1.391-3.362 2.619-5.74 2.619-3.362 0-5.166-1.637-5.166-5.155v-11.29h2.46v10.554c0 2.863 1.394 3.682 3.608 3.682 1.968 0 3.772-1.146 4.756-2.455V15.627h2.46v16.037h-2.378z",
  fill: "#FFF",
  mask: "url(#bg-white-kinedu-educators-es_svg__l)"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
  id: "bg-white-kinedu-educators-es_svg__n",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#bg-white-kinedu-educators-es_svg__m"
})), /*#__PURE__*/React.createElement("path", {
  d: "M217.546 23.645c0-4.745 3.198-8.427 8.036-8.427 2.952 0 4.674 1.227 5.904 2.782l-1.64 1.473c-1.066-1.473-2.46-2.046-4.1-2.046-3.362 0-5.576 2.618-5.576 6.137 0 3.518 2.132 6.218 5.576 6.218 1.64 0 3.034-.655 4.1-2.127l1.64 1.554c-1.23 1.555-2.952 2.782-5.904 2.782-4.756.082-8.036-3.6-8.036-8.346",
  fill: "#FFF",
  mask: "url(#bg-white-kinedu-educators-es_svg__n)"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
  id: "bg-white-kinedu-educators-es_svg__p",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#bg-white-kinedu-educators-es_svg__o"
})), /*#__PURE__*/React.createElement("path", {
  d: "M244.442 28.31v-3.028c-.984-1.31-2.624-1.964-4.428-1.964-2.378 0-4.018 1.473-4.018 3.518 0 2.046 1.64 3.519 4.018 3.519 1.722-.082 3.444-.737 4.428-2.046zm0 3.354v-1.8c-1.312 1.472-3.198 2.209-5.33 2.209-2.706 0-5.576-1.8-5.576-5.318 0-3.6 2.87-5.319 5.576-5.319 2.214 0 4.018.737 5.33 2.128V20.7c0-2.127-1.722-3.355-4.1-3.355-1.968 0-3.526.655-4.92 2.21l-1.148-1.719c1.722-1.8 3.772-2.618 6.396-2.618 3.444 0 6.232 1.555 6.232 5.4v11.046h-2.46z",
  fill: "#FFF",
  mask: "url(#bg-white-kinedu-educators-es_svg__p)"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
  id: "bg-white-kinedu-educators-es_svg__r",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#bg-white-kinedu-educators-es_svg__q"
})), /*#__PURE__*/React.createElement("path", {
  d: "M262.892 27.327v-7.2c-.902-1.39-2.788-2.618-4.756-2.618-3.28 0-5.166 2.618-5.166 6.218 0 3.518 1.968 6.137 5.166 6.137 1.968 0 3.936-1.146 4.756-2.537zm0 4.337V29.29c-1.23 1.636-3.198 2.782-5.412 2.782-4.182 0-7.134-3.191-7.134-8.428 0-5.154 2.952-8.427 7.134-8.427 2.132 0 4.1 1.064 5.412 2.864v-8.51h2.46v22.173h-2.46v-.081z",
  fill: "#FFF",
  mask: "url(#bg-white-kinedu-educators-es_svg__r)"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
  id: "bg-white-kinedu-educators-es_svg__t",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#bg-white-kinedu-educators-es_svg__s"
})), /*#__PURE__*/React.createElement("path", {
  d: "M282.08 23.645c0-3.272-1.886-6.136-5.33-6.136s-5.33 2.946-5.33 6.136c0 3.273 1.886 6.219 5.33 6.219s5.33-2.946 5.33-6.219m-13.284 0c0-4.663 3.034-8.427 7.954-8.427s7.954 3.764 7.954 8.427c0 4.664-3.034 8.428-7.954 8.428s-7.954-3.764-7.954-8.428",
  fill: "#FFF",
  mask: "url(#bg-white-kinedu-educators-es_svg__t)"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
  id: "bg-white-kinedu-educators-es_svg__v",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#bg-white-kinedu-educators-es_svg__u"
})), /*#__PURE__*/React.createElement("path", {
  d: "M288.066 31.664V15.627h2.46v2.537c1.312-1.637 3.198-2.946 5.33-2.946v2.537c-.328 0-.574-.082-.984-.082-1.558 0-3.69 1.227-4.428 2.536v11.373h-2.378v.082z",
  fill: "#FFF",
  mask: "url(#bg-white-kinedu-educators-es_svg__v)"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
  id: "bg-white-kinedu-educators-es_svg__x",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#bg-white-kinedu-educators-es_svg__w"
})), /*#__PURE__*/React.createElement("path", {
  d: "M305.368 17.345c-3.444 0-5.166 2.864-5.248 5.319h10.578c-.082-2.373-1.64-5.319-5.33-5.319m-7.872 6.3c0-4.663 3.362-8.427 7.954-8.427 4.838 0 7.708 3.764 7.708 8.591v.655H300.12c.164 3.027 2.296 5.563 5.74 5.563a7.08 7.08 0 005.002-2.045l1.23 1.636c-1.64 1.555-3.772 2.455-6.396 2.455-4.756 0-8.2-3.437-8.2-8.428",
  fill: "#FFF",
  mask: "url(#bg-white-kinedu-educators-es_svg__x)"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
  id: "bg-white-kinedu-educators-es_svg__z",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#bg-white-kinedu-educators-es_svg__y"
})), /*#__PURE__*/React.createElement("path", {
  d: "M315.126 29.536l1.23-1.8c1.066 1.228 3.116 2.291 5.33 2.291 2.46 0 3.854-1.145 3.854-2.782 0-3.845-9.922-1.472-9.922-7.445 0-2.536 2.132-4.582 5.986-4.582 2.788 0 4.674 1.064 5.986 2.291l-1.148 1.718c-.984-1.145-2.706-2.045-4.756-2.045-2.214 0-3.526 1.063-3.526 2.536 0 3.518 9.922 1.227 9.922 7.446 0 2.7-2.132 4.827-6.314 4.827-2.788.082-5.002-.736-6.642-2.455",
  fill: "#FFF",
  mask: "url(#bg-white-kinedu-educators-es_svg__z)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M154 0v35h2V0z"
}));

function SvgBgWhiteKineduEducatorsEs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 328,
    height: 35,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "static/bg-white-kinedu-educators-es.24920083.svg";
export { SvgBgWhiteKineduEducatorsEs as ReactComponent };